// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import './plugins/axios';

// Components
import './components';

// Plugins
import './plugins';

// Application imports
import App from './App';
import router from './router/index';
import store from '@/store';
import './plugins/helper';
import {
  VTooltip,
} from 'v-tooltip';

import Axios from 'axios';

// Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip);

window.Bus = new Vue;
window.Axios = axios;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');